/**
 * A mixin for date based animations.
 */

const DateBasedAnimation = {
  data () {
    return {
      date: (() => new Date())(),
      animationFrameHandle: undefined,
      visible: false
    }
  },
  methods: {
    visibilityChanged (visible) {
      this.visible = visible
      // console.log('Visibility change: ', visible ); // eslint-disable-line
    },
    sleep (duration) {
      return new Promise(resolve => setTimeout(resolve, duration))
    },
    async animateFrame () {
      if (this.visible) {
        this.date = new Date()
        // console.log('Animate.'); // eslint-disable-line
      }
      await this.sleep(900)
      this.animate()
    },
    animate () {
      if (this.animationFrameHandle) {
        window.cancelAnimationFrame(this.animationFrameHandle)
      }
      this.animationFrameHandle = window.requestAnimationFrame(
        this.animateFrame
      )
    }
  }
}

export default DateBasedAnimation
